import StatementBtn from './StatementBtn.vue';

export default StatementBtn;



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/components/statementbtn/index.ts